export default function PartnersSection() {
  const partners = [
    {
      name: '中国移动',
      type: 'text',
      icon: 'ri-smartphone-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      name: '中国联通',
      type: 'text',
      icon: 'ri-global-line',
      color: 'from-red-500 to-red-600'
    },
    {
      name: '中国电信',
      type: 'text',
      icon: 'ri-router-line',
      color: 'from-orange-500 to-red-500'
    },
    {
      name: '阿里云',
      type: 'text',
      icon: 'ri-cloud-line',
      color: 'from-orange-500 to-orange-600'
    },
    {
      name: '深兰科技',
      type: 'image',
      src: '/partners/deepblue.png',
      alt: '深兰科技 DeepBlue'
    },
    {
      name: '熠知电子',
      type: 'image',
      src: '/partners/thinkforce.png',
      alt: '熠知电子 ThinkForce'
    },
    {
      name: '芯巢科技',
      type: 'image',
      src: '/partners/xinchao.png',
      alt: '芯巢科技'
    }
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">合作伙伴</h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600">携手行业领军企业，共建云端生态</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 lg:gap-6">
          {partners.map((partner, index) => (
            <div
              key={index}
              className="group bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center min-h-[100px] sm:min-h-[120px] cursor-pointer"
            >
              {partner.type === 'image' ? (
                <img
                  src={partner.src}
                  alt={partner.alt}
                  className="max-h-8 sm:max-h-12 w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              ) : (
                <div className="flex flex-col items-center gap-1.5 sm:gap-2">
                  <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-gradient-to-br ${partner.color} flex items-center justify-center`}>
                    <i className={`${partner.icon} text-lg sm:text-2xl text-white`}></i>
                  </div>
                  <span className="text-xs sm:text-sm font-bold text-gray-800 text-center">{partner.name}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
